module.exports = __webpack_public_path__ + "images/emoji/baseball.26739c1741703f023bd5.png";